import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19b15bad&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b15bad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b15bad')) {
      api.createRecord('19b15bad', component.options)
    } else {
      api.reload('19b15bad', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=19b15bad&scoped=true", function () {
      api.rerender('19b15bad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/animateNumber/index.vue"
export default component.exports